var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfluencers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.9 27.2",
    style: {
      enableBackground: "new 0 0 31.9 27.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2_1_",
    className: "st0",
    cx: 12.3,
    cy: 7.8,
    r: 7.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_503_2_",
    className: "st0",
    d: "M0.8,26.5C0.8,20.2,5.9,15,12.2,15l0,0c6.4,0,11.5,5.2,11.5,11.5l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2_3_",
    className: "st0",
    d: "M19.7,2.1c0.2,0,0.4,0,0.7,0c0.4,0,0.7,0,1.1,0.1c3.2,0.5,5.6,3.3,5.6,6.6 c0,3.7-3,6.7-6.7,6.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_503_3_",
    className: "st0",
    d: "M20.3,15.6L20.3,15.6c6.1,0,10.9,4.9,10.9,10.9l0,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencers);
export default __webpack_public_path__ + "static/media/influencers.f596b9e9eeb3960c03a8dfd731955348.svg";
export { ForwardRef as ReactComponent };